export const Tools = (props: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 9V8.25C2.25 5.35051 4.60051 3 7.5 3H14.25V9H11.25V21H6V9H2.25ZM7.5 19.5H9.75V9H7.5V19.5ZM12.75 7.5H3.825C4.18145 5.75375 5.71774 4.49964 7.5 4.5H12.75V7.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.75 11.25V3H17.25V11.25H15V17.43C15 20.3775 16.6275 21 18 21C18.7682 21.045 19.5214 20.774 20.085 20.25C20.7644 19.4756 21.0953 18.4558 21 17.43V11.25H18.75ZM19.5 17.43C19.5683 18.0478 19.4023 18.6687 19.035 19.17C18.7434 19.4055 18.3741 19.5232 18 19.5C17.25 19.5 16.5 19.335 16.5 17.43V12.75H19.5V17.43Z"
        fill="currentColor"
      />
    </svg>
  );
};
